module.exports = __webpack_public_path__ + "img/website.70dceb7b.svg";